import { v4 as uuidv4 } from 'uuid';
//converts date from yyyy-mm-dd to dd-mm-yyyy format
const formatDate = (date) => {
    return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
  };

  //converts date from dd-mm-yyyy to yyyy-mm-dd format
  const formatDateToISO = (dateStr) => {
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  };

  const processLeadingZero = (i) => {
    return i < 10 ? '0' : '';
  }

  
const generateQINumber = (type) => {
      const prefix = type === 'quote' ? 'Q' : 'I';
      const uniqueId = uuidv4().split('-')[0]; // Use the first part of the UUID
      return `${prefix}-${uniqueId}`;
    };



const orderByTimeEarliest = (items) => {
  console.log('items',items);
    return items.sort((a, b) => {
      let result=(a.slots[0]? parseInt(a.slots[0].split(':')[0]):0) - (b.slots[0]? parseInt(b.slots[0].split(':')[0]):0);
    
      return result;
    }
    )
  
}

// Generate list of dates between start and end, filtered by weekday if provided
const generateDateRange = (start, end, weekday = null,includeWeekends=false ) => {
  const dates = [];
  let current = start;

  while (start <= end) {
    const dayOfWeek = current.getDay();

  // If not including weekends, skip Saturday and Sunday
  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
  if (!includeWeekends && isWeekend) {
    current.setDate(current.getDate() + 1);
    continue;
  }

  // If filtering by weekday name
  if (!weekday || current.toLocaleDateString('en-US', { weekday: 'long' }) === weekday) {
    dates.push(new Date(current));
  }

    current.setDate(current.getDate() + 1);
  }
  return dates;
};
 //calculating unavailability items
   // Utility to parse "dd-mm-yyyy" to Date
   const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  };
  
// Expand unavailability to individual date entries with start/end times
const expandItems = (items) => {
  const expanded = [];
  if(items.length === 0) return expanded; // Return empty array if no unavailability items
  for (const item of items) {
    const start = parseDate(item.startDate);
    const end = parseDate(item.endDate);
    const weekday = item.repeat ? item.repeatSettings.on : null;

    const days = generateDateRange(start, end, weekday,item.includeWeekends);
    //console.log('dDDDays',days);
    for (const day of days) {
      expanded.push({
        date: formatDateLabelWithoutWeekDay(day), // format: dd/mm/yyyy
        starttime: item.allDay ? '00:00' : item.startTime || '00:00',
        endtime: item.allDay ? '23:59' : item.endTime || '23:59',
      });
    }
  }
  //console.log('expanded', expanded);
  return expanded;
};

const formatDateLabelWithoutWeekDay = (dateStr) => {
  const date = new Date(dateStr);
  const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

const formatTimeOnly = (selectedDate) => {
  const hours = String(selectedDate.getHours()).padStart(2, '0'); // Extract hours
  const minutes = String(selectedDate.getMinutes()).padStart(2, '0'); // Extract minutes
  return `${hours}:${minutes}`; // Return formatted time
};

const formatShortDateLabel = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB', {
    weekday: 'short',  // 'Wed'
    day: '2-digit',    // '25'
    month: 'short',    // 'Apr'
  });
};


const convertAuDateStringWithCurrentTime = (dateString, timeStr) => {
  const [day, month, year] = dateString.split('-'); // Split the string into year, month, and day
  // Parse the time string using a Date object
  const time = new Date(`1970-01-01T${timeStr}`);

  // Extract hours and minutes from the parsed time
  const hours = time.getHours();
  const minutes = time.getMinutes();

  // Construct the final Date object
  return new Date(year, month - 1, day, hours, minutes);
};
const constructTimeWithStandardDate = (dateStr, timeStr) => {

        // Split the date string into day, month, and year
        const [year, month, day] = dateStr.split('-');

        // Parse the time string using a Date object
        const time = new Date(`1970-01-01T${timeStr}`);

        // Extract hours and minutes from the parsed time
        const hours = time.getHours();
        const minutes = time.getMinutes();

        // Construct the final Date object
        return new Date(year, month - 1, day, hours, minutes);

    }
const buildFullAddress = (selectedLocation) => {
  if (!selectedLocation) return '';

  const {
    streetNo,
    streetName,
    suburb,
    city,
    country
  } = selectedLocation;

  const parts = [];

  if (streetNo) parts.push(streetNo);
  if (streetName) parts.push(streetName);
  if (suburb) parts.push(suburb);
  if (city) parts.push(city);
  if (country) parts.push(country);

  return parts.join(', ');
};

  const isUserManager = (role) => {
        return role === 'ROLE_CMANAGER' || role === 'ROLE_MANAGER';
    }

export {formatDate,formatDateToISO,processLeadingZero,generateQINumber,orderByTimeEarliest,formatDateLabelWithoutWeekDay,expandItems,generateDateRange,formatTimeOnly,formatShortDateLabel,convertAuDateStringWithCurrentTime,buildFullAddress,constructTimeWithStandardDate,isUserManager};